export const createTemplate = () => {
  const headings = [
    'RegName',
    'RegAddress1',
    'RegAddress2',
    'RegAddressCity',
    'RegAddressCounty',
    'RegPostCode',
    'RegCountry',
    'RegNumber',
    'NumEmployees',
    'RegVatNumber'
  ];
  const examples = [
    [
      'Jane Smith Inc',
      '123 Fake Street',
      'Clapham',
      'London',
      'Surrey',
      'SW4 0AA',
      'United Kingdom',
      '123456789',
      25,
      '123456789'
    ]
  ];

  const head = headings.join(',');
  return examples.reduce((template, row) => {
    return template + '\n' + row.join(',');
  }, head);
};